import moment from 'moment-timezone';

import {head, isNonEmpty} from 'web-app/util/non-empty-array';

import type * as Types from '../types';

const getLatestPlan = <T extends Types.MaybeAlreadyBilledPlan>(plans: Array<T>): null | T => {
    const latestPlan = isNonEmpty(plans) ? head(plans) : null;

    return latestPlan ?? null;
};

const sortPlansByLatest = <T extends Types.MaybeAlreadyBilledPlan>(plans: Array<T>): Array<T> =>
    plans.sort((a, b) => (moment(a.startDate).isBefore(moment(b.startDate)) ? 1 : -1));

export {getLatestPlan, sortPlansByLatest};
